// Centralized social/contact links for Aspire Ventures
export const SOCIALS = {
  google: "https://g.co/kgs/ynebQnh",
  instagram: "https://instagram.com/aspire_ventures?igshid=MzMyNGUyNmU2YQ%3D%3D&utm_source=qr",
  facebook: "https://www.facebook.com/share/1AeMB9KLgU/?mibextid=qi2Omg",
  email: "aspireventures8@gmail.com"
};
